<template lang="pug">
  div(class="av-link-table")
    Block(
      v-if="block.innerBlocks.length"
      v-for="(innerBlock, key) in block.innerBlocks"
      v-bind="{ id: 'link-table' + '-' + key, class: 'link-table' }"
      :key="`linkTable${key}`"
      :block="innerBlock")

</template>

<script>
import { getBlockAttributes } from "~/utils/block"

export default {
  name: "AvLinkTable",

  props: {
    block: {
      type: Object, // Record<string, any>
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {}
  },

  computed: {},

  methods: {
    getBlockAttributes(block) {
      return getBlockAttributes(block)
    }
  }
}
</script>

<style lang="css" module>
:global {
  .av-link-table {
    @apply grid gap-8;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-areas:
      "link1 link2"
      "link3 link4"
      "link5 link6";

    > *:nth-child(1) {
      grid-area: link1;
    }

    > *:nth-child(2) {
      grid-area: link2;
    }

    > *:nth-child(3) {
      grid-area: link3;
    }

    > *:nth-child(4) {
      grid-area: link4;
    }

    > *:nth-child(5) {
      grid-area: link5;
    }

    > *:nth-child(6) {
      grid-area: link6;
    }

    .av-media_text {
      & > div {
        @apply w-full h-full flex flex-row items-center text-center gap-x-8 px-8;
        min-height: 54px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 8px;

        .mediaTextInnerContainer {
          a {
            @apply h-full flex items-center text-sm font-bold text-left py-8;
            line-height: normal;
            padding-left: 47px;
            padding-right: 7px;
            margin-left: -47px;
            margin-right: -8px;
          }
        }
        .imageWrap {
          img {
            min-width: 32px;
          }
        }
      }
    }
  }
}

@screen lg {
  :global {
    .av-link-table {
      @apply gap-24;
      grid-template-columns: min-content min-content;
      grid-template-rows: min-content min-content min-content;

      .av-media_text {
        & > div {
          @apply px-16;
          min-height: 74px;
          width: calc(11vw + 112px);

          .imageWrap {
            img {
              min-width: 40px;
            }
          }

          .mediaTextInnerContainer {
            a {
              @apply p-24 text-rebrandSm;
              padding-left: 64px;
              margin-left: -64px;
              margin-right: -16px;
            }
          }
        }
      }
    }
  }
}

@screen rebrandLg {
  :global {
    .av-link-table {
      .av-media_text {
        & > div {
          width: 280px;
        }
      }
    }
  }
}
</style>
